import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { transformVenues } from "~pages/Venues/utilities/transformVenues.ts";
import type { VenueResponse } from "~types/venue.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
  enabled: boolean;
};

export const useFetchVenues = ({ customParams, enabled }: Props) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const params = new URLSearchParams(
    removeEmptyFields({
      ...customParams,
      include: "sites",
    }) as Record<string, string>,
  );

  return useQuery({
    queryKey: ["venues", sport, organizationId, customParams],
    enabled: enabled,
    queryFn: () =>
      request<VenueResponse>(`${sport}/o/${organizationId}/venues?${params.toString()}`).then((response) => {
        const resources = response?.includes?.resources;
        const data = transformVenues(response?.data || [], resources);

        return transformListResponse({ ...response, data });
      }),
  });
};
